import React, { useState, useEffect } from "react";
import { Popover, Button, makeStyles } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FoldersApi } from "../../../../../api/folders/folders"; 
import * as Constants from "../../../../../data/StringConstants";
import OrgTreeView from "./OrgTreeView";


const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(2.5, 1),
        "& .Mui-disabled": {
            backgroundColor: theme.palette.grey[400]
        },
        boxShadow: "none",
        color: theme.palette.brandingV2.DarkFontColor
    },
    popoverPaper: {
        minWidth: "fit-content",
        maxHeight: "300px",
        padding: theme.spacing(2)
    },
    button: {
        backgroundColor: theme.palette.brandingV2.HeaderBackgroundColor,
        color: theme.palette.brandingV2.DarkFontColor,
		whiteSpace: "nowrap",
        border: "none",
        boxShadow: "none",
    }
}));

export default function OrgSelectPopover(props) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [orgTreeData, setOrgTreeData] = useState(null);
    const [currentOrgName, setCurrentOrgName] = useState("");

    useEffect(() => {
		fetchData();
    }, []);

    const fetchData = async () => {
        const orgTreeResp = await FoldersApi.getOrganizationTree();
        setOrgTreeData(orgTreeResp.data);

        const orgNameResp = await FoldersApi.getOrganizationName();
        setCurrentOrgName(orgNameResp.data);

        setIsLoading(false);
    };

    const handleClick = (event) => {
        setAnchorEl(event && event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const scrollToSelectedOrg = () => {
        // Once popover has rendered, scroll to the selected org in the tree
        let selected = document.getElementsByClassName('MuiTreeItem-root Mui-selected');
        let container = document.querySelector('div.MuiPaper-root.MuiPopover-paper');
        container.scrollTop = selected.length && selected[0].offsetTop;
    }

    return (orgTreeData || props.orgTreeData) ? (
        <div className={classes.root}>
            <Button 
                className={classes.button}
                variant="contained"
                color="inherit"
                onClick={handleClick}
                disabled={isLoading}
                endIcon={<ExpandMoreIcon />}
            >
                {!isLoading ? currentOrgName : Constants.LOADING}
            </Button>
            <Popover
                classes={{ paper: classes.popoverPaper }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                onEntered={scrollToSelectedOrg}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <OrgTreeView orgTree={orgTreeData} {...props} />
            </Popover>
        </div>
    ) : null;
}
